<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="primary--text">{{heading}}</h1>

        <p>
          DoleFund is a platform that enables individuals to support non-profit organizations and charities with the supplies that they need.
        </p>

        <p>
          As a non-profit or charity, you can apply to join the platform. This will create a new medium for you to find donors to support your cause.
        </p>

        <p>
          In addition to having an additional channel for collecting donations, you will have the added benefit of receiving donations directly to your office, warehouse or any location that you desire.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2>Register Your Organization For Early Access</h2>
        <OrganizationSignUpForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import OrganizationSignUpForm from './OrganizationSignUpForm.vue'

  export default {
    name: 'Organizations',
    components: {
      OrganizationSignUpForm
    },
    data: () => ({
      heading: 'For Organizations'
    })
  }
</script>
